module.exports = __webpack_public_path__ + "img/ico_coinstore_hoteapps@3x.ca376bb8.png";